import type { TranslationDict } from '../en';

const vi: TranslationDict = {
  'header.buy': 'Mua',
  'header.sell': 'Bán',
  'spend.label': 'Bạn chi',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'Bạn nhận',
  'payment.label': 'Phương thức thanh toán',
  'payment.select': 'Chọn',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'Không có phương thức thanh toán cho cặp này',
  'wallet.label': 'Địa chỉ ví nhận',
  'wallet.placeholderBuy': 'Nhập địa chỉ ví nhận của bạn',
  'wallet.placeholderSell': 'Nhập địa chỉ ví gửi của bạn',
  'wallet.validating': 'Đang xác minh địa chỉ...',
  'wallet.invalid': 'Vui lòng nhập địa chỉ ví hợp lệ',
  'wallet.invalidServer': 'Địa chỉ ví không hợp lệ',
  'cta.buy': 'Mua {crypto}',
  'cta.sell': 'Bán {crypto}',
  'cta.gettingPrice': 'Đang tìm giá tốt nhất...',
  'cta.processing': 'Đang xử lý...',
  'footer.poweredBy': 'Được cung cấp bởi ',
  'footer.brand': 'NowRamp',
  'rate.title': 'Chi tiết tỷ giá',
  'rate.close': 'Đóng',
  'rate.updatesIn': 'Tỷ giá cập nhật sau 00:{seconds}',
  'rate.noQuote': 'Không có báo giá',
  'rate.exchangeRate': 'Tỷ giá',
  'rate.processingFee': 'Phí xử lý',
  'rate.networkFee': 'Phí mạng',
  'rate.provider': 'Nhà cung cấp',
  'toast.orderCreated': 'Đã tạo lệnh',
  'toast.redirecting': 'Đang chuyển hướng đến thanh toán...',
  'toast.orderFailed': 'Lệnh thất bại',
  'toast.couldNotCreate': 'Không thể tạo lệnh',
  'toast.quoteError': 'Lỗi báo giá',
  'toast.noProviders': 'Không có nhà cung cấp',
  'toast.somethingWrong': 'Đã xảy ra lỗi',
  'error.amountZero': 'Số tiền phải lớn hơn 0',
  'error.minAmountFiat': 'Số tiền tối thiểu là {min} {currency}',
  'error.minAmountCrypto': 'Số tiền tối thiểu là {min} {currency}',
  'error.noProviders': 'Không có nhà cung cấp khả dụng cho tổ hợp này',
  'error.currencyUnavailableBuy': 'Loại tiền này không khả dụng cho lệnh mua',
  'error.currencyUnavailableSell': 'Loại tiền này không khả dụng cho lệnh bán',
  'parity.info': 'Bạn sẽ bị tính phí cho {receiveAmount} {crypto}, phần còn lại lên đến {spendAmount} {fiat} sẽ được ghi có vào tài khoản {partner} của bạn',
  'redirect.secureBadge': 'Thanh toán an toàn',
  'redirect.title': 'Tiếp tục thanh toán',
  'redirect.description': 'Bạn sẽ được chuyển hướng đến {gateway} để hoàn tất thanh toán.',
  'redirect.countdown': 'Chuyển hướng sau {seconds}...',
  'redirect.openTab': 'Mở ACH trong tab mới',
  'redirect.cancel': 'Hủy',
  'checkout.noOrder': 'Không tìm thấy lệnh',
  'checkout.goBack': 'Quay lại',
  'checkout.expired': 'Phiên thanh toán đã hết hạn',
  'checkout.expiredDesc': 'Phiên đã hết hạn. Vui lòng thử lại.',
  'checkout.startOver': 'Bắt đầu lại',
  'checkout.cancel': 'Hủy',
  'checkout.loading': 'Đang tải thanh toán...',
  'checkout.iframeTitle': 'Thanh toán nhà cung cấp',
  'checkout.widgetTitle': 'Thanh toán',
  'checkout.unknownMethod': 'Phương thức thanh toán không xác định',
  'processing.default': 'Đang xử lý lệnh của bạn...',
  'processing.pending': 'Đang chờ xác nhận thanh toán...',
  'processing.active': 'Đang xử lý giao dịch của bạn...',
  'processing.generic': 'Đang xử lý...',
  'processing.checkingStatus': 'Đang kiểm tra trạng thái...',
  'processing.orderId': 'Mã lệnh',
  'processing.provider': 'Nhà cung cấp',
  'processing.amount': 'Số tiền',
  'processing.receiving': 'Đang nhận',
  'processing.network': 'Mạng',
  'processing.toAddress': 'Địa chỉ nhận',
  'processing.usuallyMinutes': 'Quá trình này thường mất vài phút.',
  'processing.safeToClose': 'Bạn có thể đóng trang này — chúng tôi sẽ gửi email khi hoàn tất.',
  'complete.buyTitle': 'Mua thành công!',
  'complete.sellTitle': 'Bán thành công!',
  'complete.buyDesc': '{crypto} của bạn đã được gửi đến ví.',
  'complete.sellDesc': 'Khoản thanh toán {fiat} của bạn đang được xử lý.',
  'complete.amountBuy': 'Số tiền nhận',
  'complete.amountSell': 'Số tiền bán',
  'complete.paidBuy': 'Số tiền đã trả',
  'complete.paidSell': 'Số tiền thanh toán',
  'complete.network': 'Mạng',
  'complete.wallet': 'Ví',
  'complete.transaction': 'Giao dịch',
  'complete.provider': 'Nhà cung cấp',
  'complete.orderId': 'Mã lệnh',
  'complete.completed': 'Hoàn tất',
  'complete.viewExplorer': 'Xem trên Explorer',
  'complete.done': 'Xong',
  'errorStep.failed': 'Thanh toán thất bại',
  'errorStep.cancelled': 'Lệnh đã bị hủy',
  'errorStep.expired': 'Lệnh đã hết hạn',
  'errorStep.refunded': 'Lệnh đã được hoàn tiền',
  'errorStep.unknown': 'Đã xảy ra lỗi',
  'errorStep.failedBuy': 'Thanh toán của bạn không thể được xử lý. Vui lòng thử lại hoặc sử dụng phương thức thanh toán khác.',
  'errorStep.failedSell': 'Giao dịch bán của bạn không thể được xử lý. Vui lòng thử lại.',
  'errorStep.cancelledBuy': 'Lệnh của bạn đã bị hủy. Không có khoản thanh toán nào được xử lý.',
  'errorStep.cancelledSell': 'Giao dịch bán của bạn đã bị hủy. Không có tiền mã hóa nào được chuyển.',
  'errorStep.expiredBuy': 'Lệnh của bạn đã hết hạn. Vui lòng tạo giao dịch mua mới.',
  'errorStep.expiredSell': 'Lệnh của bạn đã hết hạn. Vui lòng tạo giao dịch bán mới.',
  'errorStep.refundedBuy': 'Khoản thanh toán của bạn đã được hoàn lại. Số tiền sẽ xuất hiện trong tài khoản trong vòng 5-10 ngày làm việc.',
  'errorStep.refundedSell': 'Tiền mã hóa của bạn đã được trả lại. Số tiền sẽ sớm xuất hiện trong ví của bạn.',
  'errorStep.genericDesc': 'Đã xảy ra lỗi không mong muốn. Vui lòng thử lại.',
  'errorStep.orderId': 'Mã lệnh',
  'errorStep.tryAgain': 'Thử lại',
  'errorStep.startOver': 'Bắt đầu lại',
  'errorStep.return': 'Quay lại',
  'errorStep.needHelp': 'Cần trợ giúp? Liên hệ ',
  'errorStep.reference': 'Mã tham chiếu: {orderId}',
  'confirm.buyTitle': 'Xác nhận mua',
  'confirm.sellTitle': 'Xác nhận bán',
  'confirm.loading': 'Đang tải...',
  'confirm.provider': 'Nhà cung cấp',
  'confirm.youPay': 'Bạn trả',
  'confirm.youSell': 'Bạn bán',
  'confirm.youReceive': 'Bạn nhận',
  'confirm.wallet': 'Ví',
  'confirm.network': 'Mạng',
  'confirm.refundAddress': 'Địa chỉ hoàn tiền',
  'confirm.parityNote': 'Số tiền được tính từ nhà cung cấp có thể khác. Phần còn lại lên đến {amount} {crypto} sẽ được ghi có vào tài khoản {partner} của bạn.',
  'confirm.processing': 'Đang xử lý...',
  'confirm.confirmPay': 'Xác nhận và thanh toán',
  'confirm.confirmSell': 'Xác nhận và bán',
  'confirm.payout': 'Thanh toán {currency}',
  'modal.selectFiat': 'Chọn loại tiền pháp định',
  'modal.selectCrypto': 'Chọn loại tiền mã hóa',
  'modal.choosePayment': 'Chọn phương thức thanh toán',
  'modal.selectCountry': 'Chọn quốc gia của bạn',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'Phổ biến',
  'modal.recommended': 'Được đề xuất',
  'modal.noCurrencies': 'Không tìm thấy loại tiền nào',
  'modal.noPaymentMethods': 'Không tìm thấy phương thức thanh toán nào',
  'modal.noCountries': 'Không tìm thấy quốc gia nào',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'Vị trí',
  'settings.darkMode': 'Chế độ tối',
  'settings.privacy': 'Chính sách bảo mật',
  'settings.terms': 'Điều khoản sử dụng',
  'settings.language': 'Ngôn ngữ',
  // ─── Additional ───
  'modal.chooseRamp': 'Chọn Ramp',
  'modal.bestPrice': 'Giá tốt nhất',
  'modal.noQuotes': 'Không có báo giá cho yêu cầu này',
  'modal.noProvidersFound': 'Không tìm thấy nhà cung cấp',
  'payment.unavailableFor': 'Không có phương thức thanh toán cho {currency}',
  'skeleton.poweredBy': 'Được cung cấp bởi NowRamp',
  'error.createOrderFailed': 'Không thể tạo lệnh',
  'errorStep.returnToMerchant': 'Quay lại nhà bán hàng',
  'confirm.cryptoOnNetwork': '{crypto} trên {network}',
  'payment.name.card': 'Thẻ',
  'payment.name.bankTransfer': 'Chuyển khoản ngân hàng',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default vi;
